module.exports = __webpack_public_path__ + "img/the-netherlands-diabetes-mellitus-male.ec22ad5b.png";